import { render, staticRenderFns } from "./recipeDetail.vue?vue&type=template&id=64c03335&scoped=true&"
import script from "./recipeDetail.vue?vue&type=script&lang=js&"
export * from "./recipeDetail.vue?vue&type=script&lang=js&"
import style0 from "./recipeDetail.vue?vue&type=style&index=0&id=64c03335&lang=less&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "64c03335",
  null
  
)

export default component.exports